import PinInput from "react-pin-input";
import { Box, Button, Modal, Typography } from "@mui/material";

const DEFAULT_TYPE = {
  EMAIL: {
    title: "Verifica tu correo",
    message: "Enviamos un código a tu correo por favor ingresa el código recibido"
  },
  PHONE: {
    title: "Verifica tu celular",
    message: "Enviamos un código a tu celular por favor ingresa el código recibido"
  }
};

const CodeModal = ({ 
  show, changeCode, validateCode, cancel, type
}) => {
  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={show}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "70%",
          bgcolor: "background.paper",
          boxShadow: 24,
          maxWidth: "sm",
          p: 10,
        }}
      >
        <Typography color="primary" mb={3} mt={3} variant="h4" component="h5">
          {DEFAULT_TYPE[type].title}
        </Typography>
        <Typography variant="body1" mb={3}>
          {DEFAULT_TYPE[type].message}
        </Typography>
        <PinInput
          length={4}
          onChange={(value) => changeCode(value)} 
          inputStyle={{
            marginRight: "7px", 
            borderRadius: "8px", 
            borderColor: "#0E2465"
          }}
          inputFocusStyle={{borderColor: "#7495F8"}}
        />
        <Button
          sx={{ marginTop: 3, marginBottom: 3}}
          onClick={validateCode}
          variant="contained"
          color="primary"
        >
          Validar código
        </Button>
        <Button  onClick={cancel}>
          Cancelar
        </Button>
      </Box>
    </Modal>
  );
}

export default CodeModal;
